import { render, staticRenderFns } from "./FormFilesField.vue?vue&type=template&id=5cdb11cf&"
import script from "./FormFilesField.vue?vue&type=script&lang=js&"
export * from "./FormFilesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports